module.exports = __webpack_public_path__ + "static/Diasoft-bf2b3bc920ccc4155e8d081fdddb3238.png";